import { useState } from 'react';

/**
 * Videos Preview
 * @category Functional Component
 * @summary Displays a video preview.
 * @return {Node} React node containing the video preview.
 */

const VideoPreview = props => {
  const [isMouseIn, setIsMouseIn] = useState(false);
  const { children, item } = props;

  const onMouseEnter = () => {
    setIsMouseIn(true);
  }

  const onMouseLeave = () => {
    setIsMouseIn(false);
  }

  return (
    <div onMouseEnter={ onMouseEnter } onMouseLeave={ onMouseLeave }>
      { item.field_video_mpx_id && item.field_video_mpx_id.background_video !== undefined && isMouseIn &&
        <div className='video-preview'>
          <video autoPlay muted playsInline loop>
            <source src={ item.field_video_mpx_id.background_video } type='video/mp4' />
          </video>
        </div>
      }
      { children }
    </div>
  );
}

export default VideoPreview;
